import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import NavChevron from '../../../images/nav-chevron.svg';
import { LinkStyles } from '../../Core/Link/styles';

export const Wrapper = styled.div`
  margin: 20px 0;
`;

export const BladeButton = styled.button.attrs(() => ({
  type: 'button',
}))`
  ${LinkStyles}
`;

export const CTAWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 20px;
`;

export const NavButton = styled.button`
  display: flex;
  align-items: center;
  flex: auto;
  &:before {
    content: '';
    height: 1.25rem;
    width: 1.25rem;
    background-image: url(${NavChevron});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    transform: rotate(90deg);
    margin-right: 0.75rem;
  }
`;

export const ProductWrapper = styled.div``;

export const Links = styled.ul`
  margin: 40px 0;

  li {
    display: flex;
    font-size: 1rem;
    padding: 1.125rem 1.25rem;
    border-bottom: 1px solid ${themeGet('colors.cta-border-grey')};
  }

  li:not(:first-child) {
    margin-top: 0;
  }

  li.product-block {
    flex-direction: column;
    align-items: flex-start;
    padding: 0;

    &:last-child {
      border-bottom: none;
    }
  }

  a {
    font-size: 1rem;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: ${themeGet('colors.main-text')};

    &:hover,
    &:focus {
      opacity: 0.8;
      color: ${themeGet('colors.main-text')};
      text-decoration: underline;
    }
  }

  &.submenu {
    li {
      display: flex;
    }
  }
`;

export const CtaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  a {
    &:not(:last-child) {
      border-bottom: 1px solid ${themeGet('colors.cta-border-grey')};
    }
    padding: 1.125rem 1.25rem;

    &.btn-border {
      margin-left: 1.25rem;
    }
  }
`;

export const Heading = styled.p`
  font-size: 0.875rem;
  color: ${themeGet('colors.secondary-text')};
  margin-top: 2.375rem;

  padding: 1.125rem 1.25rem;
  border-bottom: 1px solid ${themeGet('colors.cta-border-grey')};
  width: 100%;

  &.no-border {
    border-bottom: none;
  }
`;

export const Body = styled.p`
  font-size: 1rem;
  padding: 0 1.25rem 1.125rem;
  width: 100%;
`;
